import React from "react";
import styled from "@emotion/styled";
import ReactSlider from "react-slider";

export interface IToolbarSliderProps extends React.HTMLAttributes<HTMLElement> {
  prefix?: string;
  label?: string;
  onChange?: (value: any) => void;
  minValue?: any;
  maxValue?: any;
  value?: any;
  inline?: boolean;
}

const ReactSliderStyled = styled(ReactSlider)`
  max-width: 300px;
  width: 100%;
  .track {
    height: 2px;
  }
  .track-0 {
    background-image: linear-gradient(
      var(--builder-range-background),
      var(--builder-range-background)
    );
  }
  .track-1 {
    background-color: var(--builder-input-background);
    cursor: pointer;
  }
  .thumb {
    border-radius: 50%;
    border: 1px solid var(--builder-range-thumb);
    width: 10px;
    height: 10px;
    cursor: pointer;
    top: -4px;
    position: absolute;
  }
  .thumb-0 {
    background-color: var(--builder-range-thumb);
  }
`;

export const ToolbarSlider = ({
  onChange,
  value,
  prefix,
  label,
  inline,
  minValue,
  maxValue,
  ...rest
}: IToolbarSliderProps) => {
  return (
    <ReactSliderStyled
      min={minValue}
      max={maxValue}
      renderThumb={(props, state) => <div {...props}></div>}
      value={value}
      onChange={(value) => {
        onChange?.(value);
      }}
    />
  );
};
